export default "__VITE_ASSET__DCzzy1Jp__"